import { APIEnvironments } from '@evertel/api'

// Production domains take precedence over every other setting.
const PRODUCTION_HOSTNAMES = ['evertelapp.com', 'www.evertelapp.com']

// Hostname convention (docs/specs/evertel-web-cdk-refactor.md App A):
// {env}.evertelapp.com -> API env '{env}' (staging, development, demo, uat, e2e, ...).
const ENV_HOSTNAME_PATTERN = /^([a-z0-9-]+)\.evertelapp\.com$/

export interface ResolveApiEnvironmentInput {
    hostname?: string
    viteApiEnv?: string
    isElectronProduction?: boolean
}

/**
 * Resolve which API environment the web app should talk to. Resolution order:
 *   1. apex/www hostname or packaged Electron production build -> 'production'
 *   2. VITE_API_ENV override (local development)               -> that env
 *   3. hostname matching {env}.evertelapp.com                  -> '{env}' (convention)
 *   4. anything else (localhost, previews, unknown hosts)      -> 'staging'
 */
export function resolveApiEnvironment({ hostname, viteApiEnv, isElectronProduction }: ResolveApiEnvironmentInput): APIEnvironments {
    if ((hostname && PRODUCTION_HOSTNAMES.includes(hostname)) || isElectronProduction) {
        return 'production'
    }

    if (viteApiEnv) {
        return viteApiEnv
    }

    const match = hostname?.match(ENV_HOSTNAME_PATTERN)
    if (match) {
        return match[1]
    }

    return 'staging'
}
